(async () => {
    if (!customElements.get("pair-with")) {
        class PairWith extends HTMLElement {
            constructor() {
                super();
                if (!Swiper) {
                    return false
                }
                this.swiperElement = this.querySelectorAll("[data-swiper-addons-collection]");
                this.swiperOptions = {
                    loop: false,
                    autoplay: false,
                    slidesPerView: 4.5,
                    direction: "horizontal",
                    observer: false,
                    resizeEvent: "auto",
                    breakpoints: {
                        320: {
                            slidesPerView: 2.5,
                            spaceBetween: 10
                        },
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 10
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 15
                        },
                        1440: {
                            slidesPerView: 3,
                            spaceBetween: 15
                        }
                    }
                };
                if (this && this.dataset && this.dataset.options) {
                    const jsonOptions = JSON.parse(this.dataset.options);
                    if (jsonOptions) {
                        this.swiperOptions = {
                            ...this.swiperOptions,
                            ...jsonOptions
                        }
                    }
                }
                if (Shopify.designMode && this.swiperInstance) {
                    window.addEventListener("shopify:section:load", (() => {
                        this.swiperInstance.update()
                    }))
                }
                this.init()
            }
            init() {
                this.swiperElement.forEach((swiperEle => {
                    this.swiperInstance = new Swiper(swiperEle, this.swiperOptions)
                }))
            }
        }
        window.PairWith = PairWith;
        customElements.define("pair-with", PairWith)
    }
})();
//# sourceMappingURL=pair-with.js.map